"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BwmThemeContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _PaymentMethods = require("@PetSureAustralia/petsure-react-ui-library/distLib/components/UIElements/PaymentMethod/PaymentMethods");
var _defaultBrandContext = require("../../defaults/defaultBrandContext");
var _version = require("../../defaults/glm/version3");
var _contactStatement = require("../../defaults/contactStatement");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable max-len */
var BwmThemeContext = exports.BwmThemeContext = _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext), {}, {
  brand: _objectSpread(_objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.brand), _version.DefaultGlmVersion3), {}, {
    key: 'bwm',
    title: 'BWM',
    fullName: 'Bow Wow Meow',
    shortName: 'BWM',
    products: 'bwm',
    homeUrl: 'https://quote.bowwowinsurance.com.au',
    cssUrls: null,
    logos: [{
      key: 'bwmLogo',
      imageUrl: 'https://petcdnstore.blob.core.windows.net/qt-assets/Prod/bwm/images/logo-bwm-group.svg',
      redirectUrl: 'https://bowwowinsurance.com.au',
      target: '_blank'
    }],
    supportPhoneNumber: '1800 668 502',
    supportEmailAddress: 'bwm@petsure.com.au',
    partner: 'BWM',
    styleSheet: 'bwm',
    marketingPartner: 'Bow Wow Meow',
    broker: 'BWM',
    favIconUrl: 'https://petcdnstore.blob.core.windows.net/qt-assets/Non-prod/bwm/images/favicon.ico',
    partnerPrefix: 'BW',
    gtmId: 'PD826PF',
    gtmDataLayer: 'dataLayer',
    paymentMethods: /*#__PURE__*/_react["default"].createElement(_PaymentMethods.PaymentMethods, null)
  }),
  seo: {
    title: 'Bow Wow Meow Pet Insurance',
    description: 'Get a pet insurance quote online for comprehensive cover for dogs and cats. Visit any vet in Australia and add dental and routine care, like desexing.'
  },
  layout: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.layout), {}, {
    header: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.layout.header), {}, {
      contactDetails: /*#__PURE__*/_react["default"].createElement("aside", {
        className: "contactDetails"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "header-phone w-header-phone",
        id: "step1"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "header-phone-call"
      }, /*#__PURE__*/_react["default"].createElement(_components.Icon, {
        icon: "phone"
      }), /*#__PURE__*/_react["default"].createElement("div", null, "1800 668 502")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "opening-hour"
      }, " Monday \u2013 Friday, ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "value"
      }, "8:00"), /*#__PURE__*/_react["default"].createElement("span", {
        title: "Ante Meridian - before midday",
        className: "opening-hours"
      }, "am"), " \u2013 ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "value"
      }, "8:00"), /*#__PURE__*/_react["default"].createElement("span", {
        title: "Post Meridian - after midday",
        className: "opening-hours"
      }, "pm"), /*#__PURE__*/_react["default"].createElement("span", {
        title: "Australian Eastern Standard Time",
        className: "opening-hours"
      }, " AEST"))))
    }),
    main: {
      heading: {
        headingText: 'Get a quote',
        headingSecondaryText: '',
        mandatoryText: 'Mandatory fields',
        showMandatoryText: true
      }
    },
    footer: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.layout.footer), {}, {
      socialLinks: null,
      customDisclosure: {
        brand: {
          label: 'Bow Wow Meow'
        },
        tmd: {
          link: 'https://bowwowinsurance.com.au',
          label: 'bowwowinsurance.com.au.'
        },
        vetChatTAndC: {
          link: 'https://bowwowmeow.vetchat.com.au/terms-and-conditions',
          label: 'bowwowmeow.vetchat.com.au/terms-and-conditions'
        },
        vetChatSignUp: {
          link: 'https://bowwowmeow.vetchat.com.au/signup',
          label: 'bowwowmeow.vetchat.com.au/signup'
        },
        authorisedRepresentative: '',
        footerDisclaimer: function footerDisclaimer(props) {
          return /*#__PURE__*/_react["default"].createElement("p", null, "This policy is issued by PetSure (Australia) Pty Ltd ABN 95 075 949 923, AFSL 420183 (PetSure) and promoted and distributed by PetSure\u2019s Authorised Representative (AR) Bow Wow Meow Pty Ltd ABN 76 124 601 127, AR 318913. Any advice provided is general only and does not take into account your individual objectives, financial situation or needs. Please consider the Product Disclosure Statement (PDS) to ensure this product meets your needs before purchasing. ", /*#__PURE__*/_react["default"].createElement("a", {
            target: "_blank",
            rel: "noreferrer",
            href: "https://bowwowinsurance.com.au/forms-brochures",
            ref: props.disclaimerLink
          }, "PDS"), " and ", /*#__PURE__*/_react["default"].createElement("a", {
            target: "_blank",
            rel: "noreferrer",
            href: "https://bowwowinsurance.com.au/forms-brochures",
            ref: props.disclaimerLink
          }, "Target Market Determination"), " available at ", /*#__PURE__*/_react["default"].createElement("a", {
            target: "_blank",
            rel: "noreferrer",
            href: props.tmd.link,
            ref: props.disclaimerLink
          }, props.tmd.label), ".");
        },
        hasGapOnly: true,
        hasVetChat: false,
        myPetPass: {
          hasMyPetPass: true,
          eligibilityWordings: 'Available only to holders of active Bow Wow Meow Pet Insurance policies'
        },
        additionParagraph: /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("sup", null, "\u2020"), " Bow Wow Meow Pet Insurance policyholders get a 10% discount that applies to their second and subsequent Bow Wow Meow Pet Insurance policies only, based on the order that pet details are entered when you obtain a quote, or the order that policies are purchased (if purchased separately) (\"Discount\"). Discount is applied to your premium at the time of purchasing a second or subsequent policy for an additional pet, when purchased in the same transaction. For existing policyholders that wish to insure an additional pet, please call us on\xA0", /*#__PURE__*/_react["default"].createElement("a", {
          href: "tel:1800668502"
        }, "1800 668 502"), "\xA0for the Discount to apply or use instructions in quote tool above. Application and order of the Discount is reallocated across remaining policies upon a policy cancellation, where there are two (2) or more active policies. Should a policy(s) be cancelled resulting in only one (1) remaining active policy, the multi-pet discount will cease to apply on the next renewal. Discount may be used in conjunction with other offers, unless otherwise specified. Bow Wow Meow Pet Insurance reserves the right to withdraw, vary or amend this Discount at any time, without notice. Eligibility criteria applies for Bow Wow Meow Pet Insurance and is subject to the Bow Wow Meow Pet Insurance terms and conditions (Refer to the Product Disclosure Statement).")
      },
      footerSections: null,
      copyright: null,
      customContent: /*#__PURE__*/_react["default"].createElement("div", {
        className: "customFooterContent"
      }, /*#__PURE__*/_react["default"].createElement("section", {
        className: "policy"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://petsure.com.au/privacy-policy/",
        target: "_blank",
        rel: "noreferrer"
      }, "Privacy Policy"), " | View the ", /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://bowwowinsurance.com.au/forms-brochures",
        target: "_blank",
        rel: "noreferrer"
      }, "PDS and TMD")), /*#__PURE__*/_react["default"].createElement("section", {
        className: "footerContact"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.1453 15.3981C10.7613 16.0443 11.5047 16.4439 12.207 16.5225C12.9266 16.5914 13.6854 16.3537 14.5251 15.4168C14.7861 15.1265 15.0705 14.7902 15.5499 14.6286C16.0281 14.4693 16.6041 14.5679 17.2176 14.8974C18.3838 15.785 19.59 16.6835 20.7386 17.5989C21.2865 18.146 21.4279 18.8681 21.2515 19.4348C21.074 20.0024 20.6955 20.4325 20.3466 20.7925C18.3933 22.8284 16.0819 23.8112 13.8125 23.4677C11.6207 23.0877 9.49994 21.5513 7.14849 19.1968L4.35017 16.3979C1.99845 14.0451 0.463214 11.9213 0.0838142 9.72778C-0.367546 7.01486 1.07277 4.8065 2.75669 3.18978C3.11509 2.8395 3.54489 2.46038 4.11189 2.28398C4.67917 2.10702 5.40129 2.24786 5.94869 2.7961C6.86065 3.9469 7.75945 5.15286 8.64677 6.32102C8.97577 6.9345 9.07657 7.51046 8.91585 7.99038C8.75541 8.46918 8.41914 8.75478 8.12906 9.01518C7.19302 9.85518 6.95417 10.6145 7.02361 11.3347C7.10285 12.0378 7.50045 12.7812 8.1467 13.398M7.34869 14.1988C6.59157 13.4627 5.99573 12.5194 5.89269 11.4408C5.79021 10.3595 6.23989 9.18794 7.37277 8.1707C7.64829 7.92318 7.80006 7.75238 7.8415 7.6275C7.88237 7.50458 7.89526 7.3251 7.66034 6.88466L5.14985 3.59494C4.82533 3.27182 4.69625 3.28078 4.44929 3.35778C4.20401 3.43506 3.86437 3.68846 3.54965 3.99618C1.52497 6.02058 0.889654 7.73698 1.20129 9.5343C1.51209 11.3308 2.86533 13.3126 5.14929 15.5974C6.08449 16.534 7.11489 17.5644 7.94565 18.3963C10.2285 20.6811 12.2087 22.0352 14.0046 22.3479C15.8016 22.6587 17.5149 22.022 19.5385 19.9968C19.8465 19.6818 20.0991 19.343 20.1766 19.096C20.2533 18.8499 20.2629 18.7203 19.9395 18.3955L16.6523 15.8827C16.2115 15.6489 16.0326 15.6604 15.9094 15.7024C15.7848 15.7433 15.614 15.8934 15.3662 16.17C14.3504 17.3051 13.1794 17.7548 12.1003 17.6523C11.0226 17.5487 10.0801 16.9523 9.34425 16.1963M11.3967 0.573176C11.4135 0.857656 11.6935 1.10238 11.9877 1.0867C18.4899 1.0867 23.7497 6.18662 23.7497 12.4911C23.7449 12.7778 24.0123 13.0427 24.3091 13.0427C24.6051 13.0427 24.8736 12.7778 24.8694 12.4911C24.8694 5.59918 19.0961 1.60106e-05 11.9877 1.60106e-05C11.6515 -0.00250399 11.3911 0.292896 11.3967 0.573176ZM11.3967 3.83126C11.4135 4.1163 11.6935 4.36046 11.9877 4.34534C16.6341 4.34534 20.3886 7.9859 20.3886 12.4914C20.3838 12.7778 20.6529 13.0424 20.948 13.0424C21.2457 13.0424 21.5131 12.7778 21.5091 12.4914C21.5091 7.39846 17.2389 3.25866 11.9877 3.25866C11.6372 3.26258 11.3911 3.56946 11.3967 3.83126Z",
        fill: "#1EA1DA"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "footerContactDetails"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "tel://1800668502"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Need help?"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "sr-only"
      }, "Call us on "), /*#__PURE__*/_react["default"].createElement("span", null, "1800 668 502")))))
    }),
    aside: {
      campaigns: [/*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "BWMCampaign1",
        customCssClass: "BWMCampaign1",
        campaignImageDescription: "Get two months Pet Insurance free.",
        campaignBaseUrl: "https://petcdnstore.blob.core.windows.net/qt-assets",
        campaignImageUrl: function campaignImageUrl(campaignBaseUrl) {
          return "".concat(campaignBaseUrl, "/bwm/BWM_promo_tile.png");
        },
        __type: "CampaignHolder"
      }), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "BWMCampaign3",
        customCssClass: "BWMCampaign3",
        campaignImageDescription: "Ten percent discount for multiple pets.",
        campaignBaseUrl: "https://petcdnstore.blob.core.windows.net/qt-assets",
        campaignImageUrl: function campaignImageUrl(campaignBaseUrl) {
          return "".concat(campaignBaseUrl, "/bwm/BWM_multipet_tile.png");
        },
        __type: "CampaignHolder"
      }), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "BWMCampaign4",
        customCssClass: "BWMCampaign4",
        campaignImageDescription: "GapOnly logo",
        campaignBaseUrl: "https://petcdnstore.blob.core.windows.net/qt-assets",
        campaignImageUrl: function campaignImageUrl(campaignBaseUrl) {
          return "".concat(campaignBaseUrl, "/Common/GapOnly_tile_232x200.png");
        },
        __type: "CampaignHolder"
      }), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "BWMCampaign5",
        customCssClass: "BWMCampaign2",
        campaignImageDescription: "myPetPass logo",
        campaignBaseUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/",
        campaignImageUrl: function campaignImageUrl(campaignBaseUrl) {
          return "".concat(campaignBaseUrl, "/Common/MyPetPass_QT_tile_464x400.png");
        },
        __type: "CampaignHolder"
      })]
    }
  })
});
BwmThemeContext.contactStatement = function (contactStatementLogoUrl) {
  return (0, _contactStatement.coBrandContactStatement)(contactStatementLogoUrl, BwmThemeContext.brand.fullName, BwmThemeContext.brand.supportPhoneNumber, _contactStatement.petSurePhoneNumber, 'Get quote', BwmThemeContext.brand.shortName);
};
BwmThemeContext.privacyCollectionNotice = function (contactStatementLogoUrl) {
  return (0, _contactStatement.coBrandPrivacyCollectionNotice)(contactStatementLogoUrl, BwmThemeContext.brand.fullName, BwmThemeContext.brand.supportPhoneNumber, _contactStatement.petSurePhoneNumber, 'Continue to summary', BwmThemeContext.brand.supportEmailAddress, BwmThemeContext.brand.shortName);
};
var _default = exports["default"] = {
  BwmThemeContext: BwmThemeContext
};